<template>
    <div class="oferta-wrap">
        <div class="close">
            <button @click="$emit('closeOferta')">закрыть</button>
        </div>
        <div class="container">
            <h1>
                Договор оферты
            </h1>
                <ol>
                    <li>
                        ТЕРМИНЫ И ОПРЕДЕЛЕНИЯ
                        <ol>
                            <li>Заказчик — лицо, принявшее в полном объеме и без исключений условия оферты (совершившее акцепт оферты).</li>
                            <li>Исполнитель — ИП Антропов Руслан Александрович.</li>
                            <li>Интернет-сайт — интернет-сайт, имеющий адрес в сети Интернет https://medpervichka.ru/, принадлежащий Исполнителю.</li>
                            <li>Заказ — оформленное на Интернет-сайте решение Заказчика приобрести Билет на Мероприятие.</li>
                            <li>Мероприятие — зрелищные действия, которые организует ИП Антропов Руслан Александрович. Информация о Мероприятии размещена на Интернет-сайте.</li>
                            <li>Билет — электронный документ, приобретаемый за плату, удостоверяющий право на посещение Мероприятия. Один билет действителен на одно лицо.</li>
                        </ol>
                    </li>
                    <li>
                        ПРЕДМЕТ ДОГОВОРА
                        <ol>
                            <li>Предметом настоящей оферты является продажа Заказчику Билета для посещения конкретного Мероприятия из предложенных на Интернет-сайте на условиях данной Оферты.</li>
                            <li>Акцептом настоящей Оферты признается совершение Заказчиком совокупности следующих действий:
                                <ul>
                                    <li>заполнение формы заявки на Интернет-сайте;</li>
                                    <li>оплата Заказа в полном объеме.</li>
                                </ul>
                            </li>
                            <li>Акцепт Заказчика является безусловным принятием Заказчиком условий настоящего договора. Внимательно ознакомьтесь с текстом публичной оферты, и, если Вы не согласны с каким-либо пунктом оферты, Вам предлагается отказаться от покупки и/или использования услуг, предоставляемых Исполнителем.</li>
                        </ol>
                    </li>
                    <li>
                        ПРАВА И ОБЯЗАННОСТИ СТОРОН
                        <ol>
                            <li>Исполнитель обязуется:
                                <ol>
                                    <li>С момента акцепта настоящей Оферты предоставлять Заказчику Билет на Мероприятие.</li>
                                    <li>Информировать Заказчика о любых внесенных изменениях и дополнениях относительно Мероприятия посредством размещения информации об изменениях на Интернет-сайте.</li>
                                    <li>Не разглашать любую частную информацию Заказчика и не предоставлять доступ к этой информации третьим лицам, за исключением случаев, предусмотренных законодательством.</li>
                                </ol>
                            </li>
                            <li>Исполнитель имеет право:
                                <ol>
                                    <li>Требовать от Заказчика полного согласия с условиями Оферты.</li>
                                    <li>Прибегать к услугам третьих лиц для приема платежей за Билеты.</li>
                                    <li>В одностороннем порядке изменять программу Мероприятия, размещая соответствующие изменения на Интернет-сайте.</li>
                                    <li>Отключать и включать Интернет-сайт, производить профилактические работы на сервере и другом оборудовании, задействованном в работе Интернет-сайта в удобное время, информируя об этом Заказчиков на Интернет-сайте.</li>
                                    <li>Исполнитель оставляет за собой право осуществлять рассылку информационных материалов на контактные данные Заказчика. Акцепт настоящей оферты, подтверждает согласие Заказчика на получение информационных материалов, рассылок, электронных рассылок и иных рассылок, осуществляемых Исполнителем по своему усмотрению.</li>
                                </ol>
                            </li>
                            <li>Заказчик обязуется:
                                <ol>
                                    <li>До момента заключения настоящего договора ознакомиться с условиями настоящего договора и стоимостью Билетов на Интернет-сайте.</li>
                                    <li>Согласиться с условиями данной Оферты.</li>
                                    <li>Указывать достоверную информацию о своих данных при покупке Билета. В случае, когда Заказчик отказался предоставить необходимые данные, то Исполнитель вправе отказать в продаже Билета.</li>
                                    <li>Оплатить в полном объеме стоимость Билета.</li>
                                </ol>
                            </li>
                            <li>Заказчик вправе:
                                <ol>
                                    <li>Оформить покупку билета на Интернет-сайте. При этом Заказчик признает, что в случае использования сервиса Исполнителя, он в полной мере и безоговорочно принимает условия данной Оферты в независимости от того, каким способом была совершена покупка.</li>
                                    <li>Выбирать способ оплаты билета из предложенных на Интернет-сайте.</li>
                                    <li>Самостоятельно проверить данные заказа перед оформлением Билета. Заказчик несет полную ответственность за достоверность и правомерность употребления данных, использованных им при оформлении билета.</li>
                                </ol>
                            </li>
                        </ol>
                        
                    </li>
                    <li>
                        ВОЗВРАТ БИЛЕТОВ
                        <ol>
                            <li>
                                В случае одностороннего отказа Заказчика от услуг Исполнителя, денежная сумма, поступившая на расчетный счет Исполнителя по настоящему договору, возврату не подлежит, т.к. является фактически понесенными расходами Исполнителя по настоящему договору и компенсацией убытков Исполнителя, возникших ввиду одностороннего отказа Заказчика от исполнения договора.
                            </li>
                        </ol>
                    </li>
                    <li>
                        ОТВЕТСТВЕННОСТЬ И РАЗРЕШЕНИЕ СПОРОВ
                        <ol>
                            <li>Исполнитель не несет ответственности в случае неисполнения или ненадлежащего исполнения услуг со своей стороны или со стороны третьих лиц, возникших из-за недостоверности, недостаточности или несвоевременности подтверждающих сведений, предоставленных Заказчиком, а также возникших вследствие других нарушений условий настоящей Оферты со стороны Заказчика.</li>
                            <li>Исполнитель не несет ответственности в случае непосещения Заказчиком Мероприятия по обстоятельствам, независящим от Исполнителя.</li>
                            <li>Исполнитель не несет ответственности за несоответствие Мероприятия ожиданиям Заказчика и его субъективной оценке.</li>
                            <li>Стороны будут прилагать все усилия с целью достижения согласия по спорным вопросам путем переговоров. При невозможности достижения согласия на переговорах, возникшие споры подлежат рассмотрению в суде.</li>
                            <li>По всем остальным вопросам, не предусмотренным в настоящей Оферте, Стороны руководствуются действующим законодательством Российской Федерации.</li>
                        </ol>
                    </li>
                </ol>
        </div>
        <div class="close">
            <button @click="$emit('closeOferta')">закрыть</button>
        </div>
    </div>
</template>
<script>
export default {
    name: 'OfertaBlock',
    components: {},
    emits: [ 'closeOferta' ],
    props: {},
    data() {
        return {
        }
    },
    mounted() {
    },
    methods: {}
}
</script>
<style lang="scss">
.oferta-wrap{
    $color: #fff;
    $bg: #45289C;
    // $color: #000000;
    // $bg: #fff;
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    overflow-y: scroll;
    z-index: 1050;
    // background-color: #243255;
    // color: #fff;
    background-color: $bg;
    color: $color;
    text-align: left;
    h1{
        text-align: center;
        color: $color !important;
    }
    h1,p{
        margin: 1em;
    }
    ol{
        // color: $color !important;
        counter-reset: num;
        list-style: none;
        line-height: 1.25em;
        padding: 0;
        margin: 0;
        &>li{
            counter-increment: num;
            margin-top: 4px;
            margin-bottom: 4px;
            // &:first-child{
            //     text-transform: uppercase;
            //     font-weight: 600;
            // }
            &::before{
                content: counter(num)'.';
                padding: 0 8px 0 0;
            }
            &>ol{
                padding: 0;
                margin: 0;
                counter-reset: num2;
                &>li{
                    counter-increment: num2;
                    &::before{
                        content: counter(num) '.' counter(num2) '.';
                    }
                    &>ol{
                        counter-reset: num3;
                        &>li{
                            counter-increment: num3;
                            &::before{
                                content: counter(num) '.' counter(num2) '.' counter(num3) '.';
                            }
                        }
                    }
                }
            }
        }
        ul{
            list-style: none;
            li{
                margin-top: 4px;
                margin-bottom: 4px;
                &::before{
                    content: '—';
                    padding: 0 8px 0 0;
                }
            }
        }
    }
    // ol{
    //     // padding: 1em;
    //     margin: 1em;
    //     li{
    //         margin-bottom: .5em;
    //     }
    // }
    .close{
        text-align: center;
        padding: 1em;
        button{
            background-color: transparent;
            border: none;
            color: $color;
            border-bottom: solid 1px $color;
        }
    }
}
</style>